import {Icon} from '@wandb/weave/components/Icon';
import {clsx} from 'clsx';
import React, {useEffect, useState} from 'react';
import {twMerge} from 'tailwind-merge';

// An accordion section for trigger details
export const TriggerDetailsAccordion = ({
  title,
  children,
  initialOpen = false,
}: {
  title: string;
  children: React.ReactNode;
  initialOpen?: boolean;
}) => {
  const [isOpen, setIsOpen] = useState(initialOpen);

  useEffect(() => {
    setIsOpen(initialOpen);
  }, [initialOpen]);

  return (
    <>
      {/* Divider */}
      <div className="-mx-20 h-1 bg-moon-250" />

      <div
        className={twMerge(
          clsx(
            '-mx-20 flex cursor-pointer items-center justify-between px-20 py-20',
            'hover:bg-oblivion/[0.07] hover:text-moon-800 dark:hover:bg-moonbeam/[0.09] dark:hover:text-moon-200'
          )
        )}
        onClick={() => setIsOpen(!isOpen)}
        role="button"
        aria-expanded={isOpen}>
        <div className="text-lg font-semibold">{title}</div>
        <Icon name={isOpen ? 'chevron-up' : 'chevron-down'} />
      </div>
      {isOpen && <div className="mb-16 ml-16 mt-8">{children}</div>}
    </>
  );
};
